export const defaultAvatarImg =
  "https://cdn-fx.nio.com/fx/configurator-website-3D/rrwwWTAL6HN6AcSPZeN_L/avatar.png";
export const CARMODELLISTKEY = "CAR_MODEL_LIST_KEY";
export const LAST_BIND_USER_STORAGE = "LAST_BIND_USER_STORAGE";
export const PAD_APPID = "101557";
export const AREA_CODE_MAP = {
  86: "中国大陆",
  852: "中国香港",
  853: "中国澳门",
  886: "中国台湾",
};
export const SENCE_MAP = {
  STOCK: "stock_vehicle",
  QUOTATION: "quotation_order",
  UNIQUEKEY: "config_key",
};
